export const GET_ISSUES_TO_DO = 'GET_ISSUES_TO_DO'
export const GET_ISSUES_IN_PROGRESS = 'GET_ISSUES_IN_PROGRESS'
export const GET_ISSUES_DONE = 'GET_ISSUES_DONE'
